export const thingjsxTypeArr =  [
    {
        url:"zeroCode/getProjects",
        name:"全部",
        type:"项目",
        root: true
    },
    {
        url:"zeroCode/getProjects",
        // url:"zeroCode/getPark",
        name:"智慧园区",
        type:"项目",
        rootPath:"projects"
    },
    {
        url:"zeroCode/getProjects",
        // url:"zeroCode/getSchool",
        name:"智慧城市",
        type:"项目",
        rootPath:"projects"
    },
    {
        url:"zeroCode/getProjects",
        // url:"zeroCode/getPhotography",
        name:"智慧校园",
        type:"项目",
        rootPath:"projects"
    },
    {
        url:"zeroCode/getProjects",
        // url:"zeroCode/getComputerRoom",
        name:"智慧水利",
        type:"项目",
        rootPath:"projects"
    },
    {
        url:"zeroCode/getProjects",
        // url:"zeroCode/getHospital",
        name:"智慧工厂",
        type:"项目",
        rootPath:"projects"
    },
    {
        url:"zeroCode/getProjects",
        // url:"zeroCode/getSewageDisposal",
        name:"智慧交通",
        type:"项目",
        rootPath:"projects"
    },
    {
        url:"zeroCode/getProjects",
        // url:"zeroCode/getCommunity",
        name:"智慧机房",
        type:"项目",
        rootPath:"projects"
    },
    // {
    //     url:"zeroCode/getProjects",
    //     // url:"zeroCode/getWaterConservancy",
    //     name:"智慧医疗",
    //     type:"项目",
    //     rootPath:"projects"
    // },
    {
        url:"zeroCode/getProjects",
        // url:"zeroCode/getMedicalCare",
        name:"智慧农业",
        type:"项目",
        rootPath:"projects"
    },

    {
        url:"zeroCode/plugins",
        name:"全部",
        type:"插件",
        root: true
    },
    {
        url:"zeroCode/interfaceTemplate",
        name:"界面模板",
        type:"插件",
        rootPath:"plugin"
    },
    {
        url:"zeroCode/layerPlugin",
        name:"图层插件",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url:"zeroCode/extendPlugin",
        name:"扩展插件",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url:"zeroCode/corePlugin",
        name:"核心插件",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url: "zeroCode/twinsPanel",
        name:"孪生体面板",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url:"zeroCode/operatingAtom",
        name:"操作原子",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url:"zeroCode/businessPlugin",
        name:"业务插件",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url:"zeroCode/sceneControlPlugin",
        name:"场景控制插件",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url:"zeroCode/accessoriesPlugin",
        name:"标记",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url:"zeroCode/chartPlugin",
        name:"图表",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url:"zeroCode/skinPlugin",
        name:"皮肤插件",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url:"zeroCode/otherPlugin",
        name:"其他资源",
        type:"插件",
        rootPath:"plugin"

    },
    {
        url:"zeroCode/tools",
        name:"全部",
        type:"下载",
        root: true
    },

]



// WEBPACK FOOTER //
// ./src/views/thingjsX/config-type.js